import React from 'react';

import IconType from '../../../types/Icon';

const SadIcon: React.FC<IconType> = ({ color = 'currentColor', size = 64 }) => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 64 64"
			fill="none"
			xmlns="http://www.w3.org/2000/svg">
			<path
				d="M32 8C18.7656 8 8 18.7656 8 32C8 45.2344 18.7656 56 32 56C45.2344 56 56 45.2344 56 32C56 18.7656 45.2344 8 32 8ZM32 12C43.0703 12 52 20.9297 52 32C52 43.0703 43.0703 52 32 52C20.9297 52 12 43.0703 12 32C12 20.9297 20.9297 12 32 12ZM23 24C21.3438 24 20 25.3438 20 27C20 28.6562 21.3438 30 23 30C24.6562 30 26 28.6562 26 27C26 25.3438 24.6562 24 23 24ZM41 24C39.3438 24 38 25.3438 38 27C38 28.6562 39.3438 30 41 30C42.6562 30 44 28.6562 44 27C44 25.3438 42.6562 24 41 24ZM32 36C26.6641 36 21.9609 38.6719 19.0625 42.6875L22.3125 45C24.4922 41.9688 27.9844 40 32 40C36.0156 40 39.5078 41.9688 41.6875 45L44.9375 42.6875C42.0391 38.6719 37.3359 36 32 36Z"
				fill={color}
			/>
		</svg>
	);
};

export default SadIcon;
